import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import {
  GOOGLE_PERFORMANCE_URL,
  NICOTINE_QUITLINE_URL,
  RESOURCE_COORDINATOR_URL,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/urlsToHandleWithInternalNavigation'
import { openUrl } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/expo-linking'

export const useOpenUrl = () => {
  const navigate = useNavigate()

  return useCallback(
    (url: string, stayOnPage?: boolean) => {
      // Empty string url === no-op
      if (url === '') {
        return
      }

      const [urlBase, _queryParams] = url.split('?')
      switch (urlBase) {
        case RESOURCE_COORDINATOR_URL:
        case NICOTINE_QUITLINE_URL:
        case GOOGLE_PERFORMANCE_URL:
          return navigate(url)
        default:
          if (stayOnPage) {
            window.location.href = url
            return
          }
          return openUrl(url)
      }
    },
    [navigate],
  )
}
